// import type { WinDialogInfo } from "@/pages/GamePage";
// import type { GameTheme } from "@skillscratch/shared-types";
// import { retry } from "@/helpers/retry";
// import { callFirebaseFunction } from "@/bridge/callFirebaseFunction";
// import type { GameActionSetMultiplierArgs } from "@skillscratch/shared-types";
// import type { GameActionSetMultiplierRet } from "@skillscratch/shared-types";
// import { ChangingCents } from "./ChangingCents";
import { DialogBottomButtonContent } from "./DialogBottomButtonContent";
import { centsToPrettyDollars } from "@skillscratch/shared-util";
import { standardRewards } from "@/helpers/storeListings";
import type { GameTheme } from "@skillscratch/shared-types";
import { getStoreById } from "@/helpers/storeListings";

// import { CircularLoadingSpinner } from "../CircularLoadingSpinner/CircularLoadingSpinner";


// export function RewardDialogContent({
//     winDialogInfo,
//     gameTheme,
//     gamePackId,
//     gameSessionId,
//     isTutorial,
//     onNextGameClick,
//     onGoHomeClick,
//     onGameError,
//   }: {
//     winDialogInfo?: WinDialogInfo;
//     gameTheme: GameTheme;
//     gamePackId: string;
//     gameSessionId: string;
//     isTutorial: boolean;
//     onNextGameClick(): void;
//     onGoHomeClick(): void;
//     onGameError(error: Error): void;
//   }) 
  
export function RewardDialogContent({
  onNextGameClick,
  onGoHomeClick,
  isTutorial,
  gameTheme,
  foundTreasureCount
}: {
  onNextGameClick(): void;
  onGoHomeClick(): void;
  isTutorial: boolean;
  gameTheme: GameTheme;
  foundTreasureCount: number;
}
) {
  
  // const listing = storeListings.find((storeListing) => storeListing.id === gameTheme.id);
  const listing = getStoreById(gameTheme.id);
  const pricePerCard = Math.round((listing?.prices[0]?.price ?? 0) / (listing?.prices[0]?.totalCards ?? 1));
  const recomputedTotalReward = standardRewards[foundTreasureCount.toString() as keyof typeof standardRewards] * (pricePerCard as number / 100);
  const nextTierReward = standardRewards[Math.min(foundTreasureCount + 1, 10).toString() as keyof typeof standardRewards] * (pricePerCard as number / 100);

  const roundedTotalReward = Math.round(recomputedTotalReward / 100) * 100;
  const roundedNextTierReward = Math.round(nextTierReward / 100) * 100;

    return (
      <div className="flex flex-col h-72 w-full">
        {/* <div
          className="text-center"
        > */}
        <h1
          className='text-center text-4xl font-extrabold text-green mt-6 mb-0'
        >
          <span className='mr-1'>You won</span>

          <span
            style={{
              margin: "0 0.2em",
              padding: "0.2em",
              borderRadius: "0.15em",
            }}
            className='text-white bg-green text-3xl'
          >
            {centsToPrettyDollars(roundedTotalReward)}
            {/* <ChangingCents
              from={0}
              to={
                totalReward 
              }
            /> */}
          </span>
        </h1>

        <p className="text-center text-xl text-green font-extrabold mb-3 mt-4">
          1 treasure away from {centsToPrettyDollars(roundedNextTierReward)}!
        </p>

        <DialogBottomButtonContent
          onNextGameClick={onNextGameClick}
          onGoHomeClick={onGoHomeClick}
          isTutorial={isTutorial}
          middleText={`${centsToPrettyDollars(roundedTotalReward)} added to balance`}
        />

        {/* </div> */}

  
        {/* // <FadeInControlled
        //   style={{
        //     position: "absolute",
        //     inset: 0,
        //   }}
        //   isVisible={winDialogInfo === undefined}
        // >
        //   <ThemedBox
        //     theme="light"
        //     style={{
        //       width: "100%",
        //       height: "100%",
  
        //       display: "grid",
        //       placeItems: "center",
        //     }}
        //   >
        //     <CircularLoadingSpinner fillWidth />
        //   </ThemedBox>
        // </FadeInControlled> */}
      </div>
    );
  }